import {
  createSlice,
} from '@reduxjs/toolkit';
import setEntitiesState, { setBaseState } from '../../../store/utils/setStoreState';

const offersSlice = createSlice({
  name: 'offers',
  initialState: {
    entities: {
      offerInitData: {},
      activeRefundToken: '',
      AACrossToken: '',
      magazineDatas: {},
    },
    isMatchedAACrossOffer: false,
    isMatchedActiveRefundOffer: false,
  },
  reducers: {
    setOfferInitData: setEntitiesState('offerInitData'),
    setActiveRefundToken: setEntitiesState('activeRefundToken'),
    setAACrossToken: setEntitiesState('AACrossToken'),
    setMagazineDatas: setEntitiesState('magazineDatas'),
    setIsMatchedAACrossOffer: setBaseState('isMatchedAACrossOffer'),
    setIsMatchedActiveRefundOffer: setBaseState('isMatchedActiveRefundOffer'),
  },
});

export const {
  setOfferInitData,
  setActiveRefundToken,
  setAACrossToken,
  setMagazineDatas,
  setIsMatchedAACrossOffer,
  setIsMatchedActiveRefundOffer,
} = offersSlice.actions;

export default offersSlice.reducer;
